import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    title: string;
    description: string;
    cancel: string;
    confirm: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Dialog title warning about sharing restricted items */
            title: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmCreateShareDialog.title?c=36b9vg30qpwoh", defaultMessage: "You''re about to share restricted items" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Dialog description explaining Share Link access */
            description: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmCreateShareDialog.description?c=1gsu6ydjhat1z", defaultMessage: "Anyone with Share Link access can view. Subfolders will not be shared." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to cancel the Share creation */
            cancel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmCreateShareDialog.cancel?c=2ojhd8rzicmo0", defaultMessage: "Cancel" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button label to confirm and create the Share */
            confirm: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ConfirmCreateShareDialog.confirm?c=2q6axuzhi9fhl", defaultMessage: "Share" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
